import React from 'react';

export default function OrgPortalButton({ label, icon, onClick, variant }) {
	return (
		<div className={`org-portal-button${variant ? ` org-portal-button--${variant}` : ''}`} onClick={onClick}>
			{icon && <span className="org-portal-button-icon">{icon}</span>}
			<span>{label}</span>
		</div>
	);
}
